import { webDarkTheme } from "@ifgengineering/design-tokens/legacy";
import type { DefaultTheme } from "styled-components";

/** The dark palette, marked so shared controls restyle only inside the deal-anchored onboarding. */
export const ONBOARDING_SURFACE_THEME: DefaultTheme = {
  ...webDarkTheme,
  onboardingSurface: true,
};

export const isOnboardingSurface = (theme?: DefaultTheme): boolean =>
  theme?.onboardingSurface === true;
